import sidebars from './sidebars';

export default function init() {
	if (
		document.querySelector('[data-js=lazyload-embed], a[data-stolightbox]')
	) {
		import('./embeds' /* webpackChunkName: "module-embeds" */).then(mod =>
			mod.default()
		);
	}

	if (document.querySelector('[data-js=social-share-networks]')) {
		import(
			'./social-share' /* webpackChunkName: "module-social-share" */
		).then(mod => mod.default());
	}

	if (document.querySelector('#google_translate_element')) {
		import(
			'./google_translate' /* webpackChunkName: "module-translate" */
		).then(mod => mod.default());
	}

	sidebars();
}
